import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createOpportunity } from '../opportunities'

export default function useOpportunityCreate() {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation(createOpportunity, {
    onSuccess: () => {
      queryClient.invalidateQueries('opportunities')
      notification.success({
        message: 'Sucesso!',
        description: 'Cadastro realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível completar o cadastro!'
      })
    }
  })

  return { mutateAsync, isLoading }
}
